import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FACILITY_ICONS } from '../Filters/FilterResultFacilities';
import { Hotel } from 'ts/hotel/interfaces/HotelResponse';
import { FacilityTreeItem } from 'services/hotel';
import { getHotelFacilityCodes } from 'utils/hotel';
import Tooltip from 'components/ui/Tooltip/Tooltip';
interface HotelCardHotlistProps {
  hotel: Hotel;
  hotlistFacilities: FacilityTreeItem[];
}

const HotelCardHotlist: FC<HotelCardHotlistProps> = ({ hotel, hotlistFacilities }) => {
  if (!hotlistFacilities.length) {
    return null;
  }

  const hotelCodes = getHotelFacilityCodes(hotel);
  const items = hotlistFacilities.filter(
    (facility) =>
      FACILITY_ICONS[facility.facility_id] && hotelCodes.has(facility.facility_code),
  );

  if (!items.length) {
    return null;
  }

  return (
    <div className="hotel-card-hotlist">
      {items.map((item) => (
        <Tooltip key={item.facility_code} position="top" content={item.name}>
          <FontAwesomeIcon icon={FACILITY_ICONS[item.facility_id]} />
        </Tooltip>
      ))}
    </div>
  );
};

export default HotelCardHotlist;
